import { useCurrentUser } from '@common/react/user';
import { useEffect, useState } from 'react';
import { showAcceptInvitePartnerModal } from './AcceptInviteModal';

export default function useAcceptInviteModal() {
    const { incomingPartnershipInvite, partnerInfo } = useCurrentUser();
    const [invitePartnerModalShown, setInvitePartnerModalShown] =
        useState(false);

    useEffect(() => {
        if (
            !partnerInfo?.userId && // ensure that user does not have a partner
            incomingPartnershipInvite &&
            !incomingPartnershipInvite.isAccepted &&
            !invitePartnerModalShown
        ) {
            setInvitePartnerModalShown(true);
            showAcceptInvitePartnerModal();
        }
    }, [
        incomingPartnershipInvite,
        invitePartnerModalShown,
        partnerInfo?.userId,
    ]);
}
